import { Droplet, ThermometerSnowflake, Heart, ShieldCheck, Clock, Smartphone } from 'lucide-react';
import { Feature } from './types';
import { FeatureCard, SectionHeader } from './shared';

// Feature data for easier maintenance
const features: Feature[] = [
    {
        icon: <Droplet className="h-5 w-5 text-primary" />,
        title: "Wetness Detection",
        description: "Get notified instantly when your baby needs a change",
        content: "Our advanced moisture sensors detect wetness with 99.8% accuracy, alerting you immediately through our mobile app.",
        color: "primary"
    },
    {
        icon: <ThermometerSnowflake className="h-5 w-5 text-secondary" />,
        title: "Temperature Monitoring",
        description: "Keep your baby comfortable all day and night",
        content: "Smart temperature sensors track your baby's comfort level and alert you to potential overheating or cooling.",
        color: "secondary"
    },
    {
        icon: <Heart className="h-5 w-5 text-accent" />,
        title: "Health Analytics",
        description: "Monitor vital health indicators effortlessly",
        content: "Track hydration patterns, diaper change frequency, and identify potential health concerns early with our AI-powered analytics.",
        color: "accent"
    },
    {
        icon: <ShieldCheck className="h-5 w-5 text-success" />,
        title: "Hypoallergenic Materials",
        description: "Gentle on sensitive baby skin",
        content: "Our smart sensors use medical-grade, hypoallergenic materials that are safe for even the most sensitive skin.",
        color: "success"
    },
    {
        icon: <Clock className="h-5 w-5 text-warning" />,
        title: "Extended Battery Life",
        description: "Up to 6 months on a single charge",
        content: "Advanced power management technology means you won't need to worry about charging for up to 6 months of normal use.",
        color: "warning"
    },
    {
        icon: <Smartphone className="h-5 w-5 text-destructive" />,
        title: "Intuitive Mobile App",
        description: "Easy-to-use interface for busy parents",
        content: "Our beautifully designed app keeps you informed with real-time alerts and insights about your baby's health and comfort.",
        color: "destructive"
    }
];

export const Features = () => {
    return (
        <section className="container mx-auto px-4 py-16">
            <SectionHeader 
                badgeText="Why Parents Love Us"
                badgeClasses="bg-gradient-to-r from-blue-500/20 to-sky-500/20 text-blue-600 dark:text-blue-400 hover:from-blue-500/30 hover:to-sky-500/30"
                title="Smart Features for Modern Parenting"
                description="Our intelligent sensors combine with powerful analytics to give you insights about your baby's health and comfort."
            />
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                {features.map((feature, index) => (
                    <FeatureCard key={index} feature={feature} />
                ))}
            </div>
        </section>
    );
};